export default __webpack_public_path__ + "static/media/image13.4df5f20f.jpeg";